import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { installiereKonsolenMitschnitt } from "./lib/testing/contextBuffer";

// Nur Beta-Testphase: hört bei console.error/warn mit, damit eine Fehlermeldung
// die letzten Meldungen mitbringt. So früh wie möglich, sonst fehlt der Anfang.
installiereKonsolenMitschnitt();

render(<App />, document.getElementById("root"));